<template>
  <div>
    <section class="page-content">
      <form action @submit.prevent="next">
        <article class="header-title title-section-quick-quote form-section">
          <h5 class="page-title-property-inspector text-center">QUICK QUOTE <br />
            For Home Inspectors</h5>

          <h5 class="page-title-quick-quote text-center">Get a Premium Indication in 2 Minutes! <br />Includes Errors and Omissions (E&O) and General Liability in a single policy. </h5>

          <p
              class="page-desc-quick-quote text-center"
          >Premium indication subject to completion of a full application and underwriting approval. </p>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">1.</span>Name of Firm:
          </label>
          <input
            type="text"
            name="nameOfFirm"
            v-model="quickQuote.nameOfFirm"
            class="orep-text-input"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
          >
          <span
            v-show="errors.has('nameOfFirm')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('nameOfFirm') | filterText }}</span>
        </article>
        <article class="form-section">
          <div class="input-section" >
            <div class="row pb-3">
              <div class="col-md-6">
                <label for class="orep-label mb-0 ml-1"><span class="mr-1">2.</span>
                  Address Street:
                </label>
                <input
                  type="text"
                  name="address"
                  v-model="quickQuote.customer.address"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('address')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('address') | filterText }}</span>
              </div>
              <div class="col-md-6">
                <label for class="orep-label mb-0 ml-1">
                  City:
                </label>
                <input
                  type="text"
                  name="city"
                  v-model="quickQuote.customer.city"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('city')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('city') | filterText }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-4">
                <label for class="orep-label mb-0 ml-1">
                  State:
                </label>
                <select
                  class="orep-select w-100"
                  style="height: 40px; width: 383px;"
                  name="state"
                  v-model="quickQuote.customer.state"
                  v-validate="'required'"
                  @change="validateBeforeSubmit()"
                >
                  <option v-for="(item, key) in states" :value="key">
                    {{item}}
                  </option>
                </select>
                <span
                  v-show="errors.has('state')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('state') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0 ml-1">
                  ZIP Code:
                </label>
                <input
                  type="text"
                  name="zipCode"
                  v-model="quickQuote.customer.zipCode"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('zipCode')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('zipCode') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0 ml-1">
                  County:
                </label>
                <input
                  type="text"
                  name="county"
                  v-model="quickQuote.customer.county"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('county')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('county') | filterText }}</span>
              </div>
            </div>


          </div>

        </article>
        <article class="input-section form-section">
          <div class="row pb-3">
            <div class="col-md-4">
              <label for class="orep-label mb-0">
                <span class="mr-1">4.</span>Email:
              </label>
              <input
                type="email"
                name="email"
                autocomplete="email"
                v-model="quickQuote.customer.email"
                class="orep-text-input w-100"
                v-validate="'required|email'"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('email')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('email') | filterText }}</span>
            </div>
            <div class="col-md-4">
              <label for class="orep-label mb-0">
                <span class="qtn mrpx-5"></span>Phone:
              </label>
              <input
                  type="text"
                  name="phone"
                  v-model="quickQuote.customer.phone"
                  v-validate="'required'"
                  class="orep-text-input w-100"
              >
              <span
                  v-show="errors.has('phone')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('phone') | filterText }}</span>
            </div>

          </div>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="qtn mrpx-5">5. </span>Years of Experience:
          </label>
          <div class="radio orep-radio-wrapper">
            <label>
              <input
                  type="radio"
                  name="yearsOfExperience"
                  value="less-3"
                  class="orep-radio"
                  v-validate="'required|included:less-3,3-to-7,more-than-7'"
                  @change="validateBeforeSubmit()"
                  v-model="quickQuote.homeInspectingExperience"
              >
              <span class="radio-span">0-2 Years</span>
            </label>
          </div>
          <div class="radio orep-radio-wrapper">
            <label>
              <input
                  type="radio"
                  name="yearsOfExperience"
                  value="3-to-7"
                  class="orep-radio"
                  @change="validateBeforeSubmit()"
                  v-model="quickQuote.homeInspectingExperience"
              >
              <span class="radio-span">3-6 years</span>
            </label>
          </div>
          <div class="radio orep-radio-wrapper">
            <label>
              <input
                  type="radio"
                  name="yearsOfExperience"
                  value="more-than-7"
                  class="orep-radio"
                  @change="validateBeforeSubmit()"
                  v-model="quickQuote.homeInspectingExperience"
              >
              <span class="radio-span">7 or more</span>
            </label>
          </div>
          <span
              v-show="errors.has('yearsOfExperience')"
              class="help is-danger form-errors text-danger"
          >{{ errors.first('yearsOfExperience') | filterText }}</span>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">6.</span>Annual Revenue:
          </label>
            <div class="row" style="margin-right: 56px;">
              <div class="col-md-4">
                <input
                    type="number"
                    oninput="this.value=(parseInt(this.value)||0)"
                    class="orep-text-input w-100"
                    name="expectedAnnualRevenue"
                    v-validate="'numeric'"
                    @input="validateBeforeSubmit()"
                    v-model="quickQuote.expectedAnnualRevenue"
                >
                <span
                    v-show="errors.has('expectedAnnualRevenue')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('expectedAnnualRevenue') | filterText }}</span>

              </div>
            </div>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12 pr-0 pl-0">
              <label for class="orep-label">
                <span class="qtn mrpx-5">7.</span>Do you use a limitation of liability in your Pre-Inspection Agreement?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="doYouUseLimitationOfLiability"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="quickQuote.doYouUseLimitationOfLiability"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="doYouUseLimitationOfLiability"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="quickQuote.doYouUseLimitationOfLiability"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('doYouUseLimitationOfLiability')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('doYouUseLimitationOfLiability') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12 pr-0 pl-0">
              <label for class="orep-label">
                <span class="qtn mrpx-5">8.</span>Are you Licensed or a Member of a Professional Association?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="memberOfLicensedProfessional"
                        value="yes"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="quickQuote.memberOfLicensedProfessional"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="memberOfLicensedProfessional"
                        value="no"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="quickQuote.memberOfLicensedProfessional"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('memberOfLicensedProfessional')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('memberOfLicensedProfessional') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12 pr-0 pl-0">
              <label for class="orep-label">
                <span class="qtn mrpx-5">9.</span>Any Claims or State Board Complaints in the last 5 years?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="anyClaimsInLastFiveYears"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="quickQuote.anyClaimsInLastFiveYears"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="anyClaimsInLastFiveYears"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="quickQuote.anyClaimsInLastFiveYears"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('anyClaimsInLastFiveYears')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('anyClaimsInLastFiveYears') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="qtn mrpx-5">10.</span>Limit of Coverage Requested:
          </label>
          <div class="radio orep-radio-wrapper solo-checkbox">
            <label>
              <input
                  type="checkbox"
                  name="desiredCoverage"
                  id="claim-three"
                  value="1M/1M"
                  class="orep-radio"
                  :checked="quickQuote.desiredCoverage.find(coverage => coverage === '1M/1M')"
                  v-validate="'required|included:1M/1M,0.5M/0.5M,0.1M/0.3M,0.3M/0.3M,other'"
                  @change="validateBeforeSubmit() + desiredCoverage($event)"
              >
              <span class="radio-span solo-checkbox-span">$1,000,000 Per Claim / $1,000,000 Aggregate</span>
            </label>
          </div>
          <div class="radio orep-radio-wrapper solo-checkbox">
            <label>
              <input
                  type="checkbox"
                  name="desiredCoverage"
                  id="claim-two"
                  value="0.5M/0.5M"
                  class="orep-radio"
                  :checked="quickQuote.desiredCoverage.find(coverage => coverage === '0.5M/0.5M')"
                  @change="validateBeforeSubmit() + desiredCoverage($event)"
              >
              <span class="radio-span solo-checkbox-span">$500,000 Per Claim / $500,000 Aggregate</span>
            </label>
          </div>
          <div class="radio orep-radio-wrapper solo-checkbox">
            <label>
              <input
                  type="checkbox"
                  name="desiredCoverage"
                  id="claim-four"
                  value="0.3M/0.3M"
                  class="orep-radio"
                  :checked="quickQuote.desiredCoverage.find(coverage => coverage === '0.3M/0.3M')"
                  @change="validateBeforeSubmit() + desiredCoverage($event)"
              >
              <span class="radio-span solo-checkbox-span">$300,000 Per Claim / $300,000 Aggregate</span>
            </label>
          </div>
          <div class="radio orep-radio-wrapper solo-checkbox">
            <label>
              <input
                  type="checkbox"
                  name="desiredCoverage"
                  id="claim-one"
                  value="0.1M/0.3M"
                  class="orep-radio"
                  :checked="quickQuote.desiredCoverage.find(coverage => coverage === '0.1M/0.3M')"
                  @change="validateBeforeSubmit() + desiredCoverage($event)"
              >
              <span class="radio-span solo-checkbox-span">$100,000 Per Claim / $300,000 Aggregate</span>
            </label>
          </div>
          <span
              v-show="errors.has('desiredCoverage')"
              class="help is-danger form-errors text-danger"
          >{{ errors.first('desiredCoverage') | filterText }}</span>
        </article>
        <article v-if="this.$store.getters.getHostname !== 'www.liabilityinsuranceapps.com'" class="d-flex form-heading title-section form-section center-block" style="flex-direction: column; align-items: center;">
          <label for="hear_about_us" class="orep-label proposal-title blue-color"
                 style="text-align: center; margin-bottom: 10px;margin-top: 30px;">
            <strong>How Did You Hear About Us?</strong>
          </label>
          <select
              class="orep-select"
              style="height: 40px; width: 383px;"
              name="hear_about_us"
              v-model="quickQuote.hearAboutUs"
              v-validate="'required'"
              @change="validateBeforeSubmit()"
          >
            <option v-for="(item, key) in hear_about_us" :value="item">
              {{ item }}
            </option>
          </select>
          <span
              v-show="errors.has('hear_about_us')"
              class="help is-danger form-errors text-danger"
          >
              {{ errors.first('hear_about_us') | filterText }}
            </span>

          <div class="input-section">
            <input
                v-if="quickQuote.hearAboutUs === 'Other'"
                type="text"
                name="hearAboutUsOtherDetails"
                class="orep-text-input mr-1"
                v-model="quickQuote.hearAboutUsOtherDetails"
                placeholder="Please Provide Details"
                @input="validateBeforeSubmit()"
            >
            <span
                v-show="errors.has('hearAboutUsOtherDetails')"
                class="help is-danger form-errors text-danger"
            >{{ errors.first('hearAboutUsOtherDetails') | filterText }}</span>
          </div>
        </article>
      </form>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <article class="orep-pagination">
              <span class="pagination-dots pagination-current"></span>
              <button class="pagination-dots" :disabled="!state.pageOneIsValid" @click="next('quick-quote-representation')" ></button>

            </article>
            <button type="submit"
                    class="next-btn mont spaced text-uppercase"
                    @click="formSubmit()"
                    :disabled="!state.pageOneIsValid"
                    :class="{submitDisabled: !state.pageOneIsValid}">Submit</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import {APP_STATUS, HEAR_ABOUT_US_HI, STATES, STATUS} from "../../utils/constants";
import Datepicker from 'vuejs-datepicker';
import moment from "moment";

export default {
  name: "quick-quote-1",
  computedDates () {
    return moment(this.value).format('YYYY-MM-D')
  },
  data() {
    return {
      hear_about_us: HEAR_ABOUT_US_HI,
      states: STATES
    };
  },
  computed: {
    quickQuote() {
      return this.$store.state.quickQuote.quickQuote;
    },
    state() {
      return this.$store.state.quickQuote;
    },
    errorMsg() {
      return this.$store.state.quickQuote.errorMsg;
    },
    getApplicantType() {
      var route = this.$route.path;
      var first = route.substring(0, route.lastIndexOf("/") + 1);
      if (first === '/portal/quick-quote-amba' || first === '/portal/quick-quote-amba/' || this.quickQuote.customer.partnerName === 'Mercer'){
        return 'Mercer';
      }else if (first === '/portal/quick-quote-realshield' || first === '/portal/quick-quote-realshield/' || this.quickQuote.customer.partnerName === 'Realshield'){
        return 'Realshield';
      }else if (first === '/portal/quick-quote-spmga' || first === '/portal/quick-quote-spmga/' || this.quickQuote.customer.partnerName === 'spmga'){
        return 'spmga';
      }
      else {
        return 'OREP';
      }
    },
  },

  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },

  methods: {
    desiredCoverage(event) {
      if(!this.quickQuote.desiredCoverage.find(coverage => coverage === event.target.value)) {
        if (this.quickQuote.desiredCoverage.length < 1) {
          this.quickQuote.desiredCoverage.push(event.target.value);
        } else {
          this.$notify({
            group: 'error',
            type: 'warning',
            title: 'Warning',
            text: 'You can select up to 1 coverages.'
          });
          event.target.checked = false
        }
      } else {
        this.quickQuote.desiredCoverage = this.quickQuote.desiredCoverage.filter(coverage => coverage !== event.target.value);
      }
    },
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    formattedCurrentDate() {
      return moment(this.quickQuote.appraiserEsignatureDatetime).format('YYYY-MM-DD');
    },
    formSubmit() {
      this.loading = true;
      this.quickQuote.status = STATUS.Submitted;
      this.quickQuote.customer.isQuickQuoteApplication = 'True';
      this.quickQuote.customer.appStatus = APP_STATUS.Completed;
      this.quickQuote.customer.contactName = this.state.quickQuote.nameOfFirm;
      this.quickQuote.customer.companyName = this.state.quickQuote.nameOfApplicant;
      if (this.getApplicantType === 'Mercer'){
        this.quickQuote.customer.partnerName = 'Mercer';
      }
      else if (this.getApplicantType === 'Realshield'){
        this.quickQuote.customer.partnerName = 'Realshield';
      }
      else if (this.getApplicantType === 'spmga'){
        this.quickQuote.customer.partnerName = 'spmga';
      }
      this.$store.dispatch('quickQuote/createQuickQuote');
    },
    pageOneSubmit(routeName) {
      this.loading = true;
      this.quickQuote.status = STATUS.Submitted;
      this.quickQuote.customer.isQuickQuoteApplication = 'True';
      this.quickQuote.customer.appStatus = APP_STATUS.Completed;
      this.$store.dispatch('quickQuote/createQuickQuote');

      this.quickQuote.customer.contactName = this.state.quickQuote.nameOfFirm;
      this.quickQuote.customer.companyName = this.state.quickQuote.nameOfApplicant;
      if (this.getApplicantType === 'Mercer'){
        this.quickQuote.customer.partnerName = 'Mercer';
      }
      else if (this.getApplicantType === 'Realshield'){
        this.quickQuote.customer.partnerName = 'Realshield';
      }
      else if (this.getApplicantType === 'spmga'){
        this.quickQuote.customer.partnerName = 'spmga';
      }
      this.$store.dispatch('quickQuote/createCustomer');

      // this.$router.push({
      //   name: routeName,
      // });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    },
    validateBeforeSubmitCheck(e){
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    }
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    const params = this.$route.query;
    if (params && params.filter) {
      this.state.quickQuote.applicantRequestFrom = params.filter;
    }
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },
  components: {
    Datepicker
  }
};
</script>

<style scoped>

</style>
